import React, { useState } from "react";
import { ReactComponent as DeleteIcon } from "../../../../assets/trash.svg";

function SeatingStyle({
  seatingData,
  setSeatingData,
  errors,
  handleRemoveSeating,
  handleAddSeating,
}) {
  const handleChange = (index, field, value) => {
    setSeatingData(
      seatingData.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };

  const handleSubTypeChange = (index, subIndex, field, value) => {
    setSeatingData(
      seatingData.map((item, i) =>
        i === index
          ? {
              ...item,
              subTypesAndAccommadations: item.subTypesAndAccommadations.map(
                (subItem, subI) =>
                  subI === subIndex ? { ...subItem, [field]: value } : subItem
              ),
            }
          : item
      )
    );
  };

  return (
    <div className="bg-[#f0f2f7] p-3">
      {seatingData.map((seating, index) => (
        <div
          key={index}
          className="row row-cols-lg-3 row-cols-1 pb-3 border-bottom mb-2"
        >
          <div className="col">
            <label className="text-sm font-medium" htmlFor="">
              Seating Style
            </label>
            <select
              name="seatingStyle"
              className="custom-input"
              value={seating?.seatingStyle || ""}
              onChange={(e) =>
                handleChange(index, "seatingStyle", e.target.value)
              }
            >
              <option value="">Select Style</option>
              <option value="table">Table</option>
              <option value="chair">Chair</option>
              <option value="u-shape">U-Shape</option>
              <option value="theater">Theater</option>
            </select>
            {errors[index]?.seatingStyle && (
              <span className="text-red-500 text-xs">
                {errors[index].seatingStyle}
              </span>
            )}
          </div>

          <div className="col">
            <label className="text-sm font-medium" htmlFor="">
              Min people capacity*
            </label>
            <input
              type="number"
              className="custom-input"
              value={seating?.minPersonCapacity || ""}
              onChange={(e) =>
                handleChange(index, "minPersonCapacity", e.target.value)
              }
            />
            {errors[index]?.minPersonCapacity && (
              <span className="text-red-500 text-xs">
                {errors[index].minPersonCapacity}
              </span>
            )}
          </div>

          <div className="col">
            <label className="text-sm font-medium" htmlFor="">
              Max people capacity*
            </label>
            <input
              type="number"
              className="custom-input"
              value={seating?.maxPersonCapacity || ""}
              onChange={(e) =>
                handleChange(index, "maxPersonCapacity", e.target.value)
              }
            />
            {errors[index]?.maxPersonCapacity && (
              <span className="text-red-500 text-xs">
                {errors[index].maxPersonCapacity}
              </span>
            )}
          </div>

          {/* Subtypes and Accommodations Section */}
          {seating?.subTypesAndAccommadations?.map((subType, subIndex) => (
            <div key={subIndex} className="mt-3">
              <div className="flex justify-between gap-2">
                <div className="w-fit">
                  <label className="text-sm font-medium" htmlFor="">
                    SubType {subIndex + 1}
                  </label>
                  <input
                    type="text"
                    className="custom-input"
                    value={subType?.subType || ""}
                    onChange={(e) =>
                      handleSubTypeChange(
                        index,
                        subIndex,
                        "subType",
                        e.target.value
                      )
                    }
                  />
                  {errors[index]?.[`subType${subIndex}`] && (
                    <span className="text-red-500 text-xs">
                      {errors[index][`subType${subIndex}`]}
                    </span>
                  )}
                </div>

                <div className="">
                  <label className="text-sm font-medium" htmlFor="">
                    Accommodation
                  </label>
                  <input
                    type="text"
                    className="custom-input"
                    value={subType?.accomodation || ""}
                    onChange={(e) =>
                      handleSubTypeChange(
                        index,
                        subIndex,
                        "accomodation",
                        e.target.value
                      )
                    }
                  />
                  {errors[index]?.[`accomodation${subIndex}`] && (
                    <span className="text-red-500 text-xs">
                      {errors[index][`accomodation${subIndex}`]}
                    </span>
                  )}
                </div>

                <div className="flex justify-end">
                  <button
                    className="pt-4"
                    onClick={() => {
                      const updatedSeating = [...seatingData];
                      updatedSeating[index].subTypesAndAccommadations.splice(
                        subIndex,
                        1
                      );
                      setSeatingData(updatedSeating);
                    }}
                  >
                    <DeleteIcon />
                  </button>
                </div>
              </div>
            </div>
          ))}

          <div className="flex justify-center items-end mt-3 ">
            <button
              onClick={() => {
                const updatedSeating = [...seatingData];
                updatedSeating[index].subTypesAndAccommadations?.push({
                  subType: "",
                  accomodation: "",
                });
                setSeatingData(updatedSeating);
              }}
              className="custom-input"
            >
              + Add SubType
            </button>
          </div>
        </div>
      ))}

      {/* <div className="col mt-4">
        <button onClick={handleAddSeating} className="custom-input">
          + Add More Seating Style
        </button>
      </div> */}
    </div>
  );
}

export default SeatingStyle;
